export default __webpack_public_path__ + "static/media/terms-of-service.2a6ce27c.pdf";